// ReattestationBanner — annual health check-in reminder on Mode 2
// dashboard when universal core is within 14 days of expiry.
// Also renders a "triggered" variant when adding a new program after the
// universal core has expired.
// Spec: Sprint 7 of VOYA9_Frontend_Assessment_Multiprogram_Modes.md
import { Link } from "react-router-dom";
import { C } from "@/lib/brand";

export default function ReattestationBanner({ universalCore, variant = "annual", onDismiss }) {
  if (!universalCore) return null;

  if (variant === "triggered") {
    return (
      <section data-testid="reattestation-triggered" style={{ padding: "14px 24px 0" }}>
        <div
          style={{
            maxWidth: 1100, margin: "0 auto",
            background: C.peach, color: C.peachDark,
            padding: "22px 22px",
          }}
        >
          <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em" }}>★ QUICK SAFETY REVIEW</div>
          <div style={{ marginTop: 8, fontSize: 20, fontWeight: 800, letterSpacing: "-0.02em", color: C.ink }}>
            Before starting your new program.
          </div>
          <p style={{ marginTop: 8, fontSize: 13, lineHeight: 1.5, opacity: 0.88 }}>
            Adding a new program triggers a brief safety review so your physician has up-to-date info.
            Takes 2-3 minutes · $19 review fee.
          </p>
          <div style={{ marginTop: 14 }}>
            <Link
              to="/app/reattestation?triggered=1"
              data-testid="reattestation-begin-triggered"
              style={{
                display: "inline-block",
                padding: "12px 18px",
                background: C.ink, color: C.cream,
                fontSize: 12, fontWeight: 800, letterSpacing: "0.2em",
                textDecoration: "none",
              }}
            >
              BEGIN REVIEW →
            </Link>
          </div>
        </div>
      </section>
    );
  }

  // Annual (default)
  const daysText = typeof universalCore.daysUntilExpiry === "number"
    ? (universalCore.daysUntilExpiry <= 0 ? "today" : `in ${universalCore.daysUntilExpiry} day${universalCore.daysUntilExpiry === 1 ? "" : "s"}`)
    : "soon";

  return (
    <section data-testid="reattestation-annual" style={{ padding: "14px 24px 0" }}>
      <div
        style={{
          maxWidth: 1100, margin: "0 auto",
          background: C.bone, color: C.ink,
          padding: "22px",
          display: "flex", gap: 18, alignItems: "center", flexWrap: "wrap", justifyContent: "space-between",
          borderLeft: `3px solid ${C.peachDeep}`,
        }}
      >
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em", color: C.peachDeep }}>
            ★ ANNUAL HEALTH CHECK-IN
          </div>
          <div style={{ marginTop: 6, fontSize: 16, fontWeight: 700, color: C.ink, letterSpacing: "-0.01em" }}>
            Your health profile is due for its yearly review {daysText}.
          </div>
          <div style={{ marginTop: 4, fontSize: 13, color: C.warmGray }}>
            Takes about 3 minutes — and it's free.
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, flexShrink: 0 }}>
          <Link
            to="/app/reattestation"
            data-testid="reattestation-begin-annual"
            style={{
              padding: "12px 18px",
              background: C.ink, color: C.cream,
              fontSize: 12, fontWeight: 800, letterSpacing: "0.18em",
              textDecoration: "none",
            }}
          >
            REVIEW NOW →
          </Link>
          {onDismiss && (
            <button
              type="button"
              data-testid="reattestation-dismiss"
              onClick={onDismiss}
              style={{
                background: "transparent", border: 0, color: C.warmGray,
                fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", cursor: "pointer",
              }}
            >
              Remind me later
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
